// @core/api/endpoints/authn/get_oauth2_client.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OAuth2ClientResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get OAuth2 client details
 * Retrieves configuration and metadata for a specific OAuth2 client. Does not return the client secret for security reasons.
 */
export async function GetOAuth2Client(
  client_id: string,
  options?: RequestOptions
): Promise<OAuth2ClientResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/clients/:client_id`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.get<OAuth2ClientResponse>(requestPath, { ...requestOptions });
}
